<script setup lang="ts">
const data = inject(keys.packetVariantCard)
</script>

<template>
  <div v-if="data?.primary">
    <h3 class="text-2xl md:text-4xl" :class="data.classes.title()">
      <slot name="title">
        {{ data.primary.title || data.primary.customName || data.primary.name }}
      </slot>
    </h3>
    <p
      v-if="data.primary.subtitle"
      :class="data.classes.subtitle()"
      v-text="data.primary.subtitle"
    />
  </div>
</template>
